import React from 'react'
import { CaretDownOutlined, EyeOutlined, FormOutlined } from '@ant-design/icons';
import { Row, Col, Select, Modal, Button, Input } from "antd";
import Message from "../../../cmpts/ant/Message";
// import {
//     URL_GET_MSG_TEMPLATE_TASK_ACTIVE_LIST,
//     URL_GET_MSG_TEMPLATE_MSG_SYNC,
//     URL_GROUPBUY_NOTICECONFIG_ADD,
//     URL_GROUPBUY_NOTICECONFIG_EDIT,
//     URL_GROUPBUY_NOTICECONFIG_DETAIL,
//     URL_MXD_GROUPBUY_NOTICE_DETAIL, URL_MXD_CONF_SUBS_BASEINFO, URLMXD_SUBS_MAG_TEMPLATE_LIST,
//     URL_MXD_GROUPBUY_NOTICE_ADD
//
// } from '../../../public/variables'
import styles from "../../../common/templateMsg/template_msg.css";
import MsgTemplate from '../../../cmpts/msgTemplate/msgTemplate'
import TaskposterUtil from "../../../ext/taskpost/taskposter_util";
import SubsSelector from "../../../cmpts/selector/SubsSelector";
import DashedAddButton from '../../../cmpts/button/DashedAddButton'
import manageStyles from "../../../common/templateMsg/msg_manage.css";
import MsgPreview from "../../../common/templateMsg/msg_preview";
import PopupMask from '../../../cmpts/PopupMask'
import {Path} from "../../../public/path";
import Vars from "../../../cmpts/system_vars";
import Api from "../../../public/api";

/**
 * 订单管理
 */

class GroupCodeData extends React.Component {
    constructor(props) {
        super(props);
        this.getSelectedFn = this.getSelectedFn.bind(this);
        this.getMsgTemp = this.getMsgTemp.bind(this);
        this.setMsgData = this.setMsgData.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.getData = this.getData.bind(this);
        this.submitData = this.submitData.bind(this);
        this.getConfigId = this.getConfigId.bind(this);
        this.showEditTemplateMsg = this.showEditTemplateMsg.bind(this);
        this.setTempMsg = this.setTempMsg.bind(this);
        this.setTempIndex = this.setTempIndex.bind(this);
        this.clearMsgTemp = this.clearMsgTemp.bind(this);
        this.isExit = this.isExit.bind(this);
        this.cancelMsgData = this.cancelMsgData.bind(this);
        this.state = {
            name: null,
            list: null,
            pagInfo: null,
            visible: false,
            keynote_list: [],
            content: "{{first.DATA}}TEMP_MXD_ENTER活动名称：{{keyword1.DATA}}TEMP_MXD_ENTER当前助力人数：{{keyword2.DATA}}TEMP_MXD_ENTER{{remark.DATA}}",
            msg: null,
            msgTemp: [],
            subscriptionList: [],
            appIdIndex: null,
            template_id: null,
            msgList: [
                {
                    key: 'groupCreateMsg',
                    name: '开团成功通知',
                    currentMsg: null,
                    template_id: null,
                    vars: [
                        Vars.GOODS_NAME(),
                        Vars.GOODS_AMOUNT(),
                        Vars.GROUP_NUM(),
                        Vars.GROUP_LIMITEDTIME(),
                        Vars.GROUP_CREATER(),
                    ]
                },
                {
                    key: 'friendPartGroupMsg',
                    name: '好友参团成功通知',
                    currentMsg: null,
                    template_id: null,
                    vars: [
                        Vars.GOODS_NAME(),
                        Vars.DATETIME(),
                        Vars.GOODS_AMOUNT(),
                        Vars.GROUP_NUM(),
                        Vars.FROM_NICKNAME(),
                        Vars.GROUP_PART_NUM(),
                    ]
                },
                {
                    key: 'partGroupMsg',
                    name: '自己参团成功通知',
                    currentMsg: null,
                    template_id: null,
                    vars: [
                        Vars.GOODS_NAME(),
                        Vars.DATETIME(),
                        Vars.GOODS_AMOUNT(),
                        Vars.GROUP_NUM(),
                        Vars.GROUP_ENDDATE(),
                        Vars.GROUP_PART_NUM(),
                        Vars.GROUP_CREATER(),
                    ]
                },
                {
                    key: 'groupSuccessMsg',
                    name: '拼团成功通知',
                    currentMsg: null,
                    template_id: null,
                    vars: [
                        Vars.GOODS_NAME(),
                        Vars.DATETIME(),
                        Vars.GOODS_AMOUNT(),
                        Vars.GROUP_NUM(),
                        Vars.GROUP_CREATER(),
                    ]
                },
                {
                    key: 'groupFailMsg',
                    name: '拼团失败通知',
                    currentMsg: null,
                    template_id: null,
                    vars: [
                        Vars.GOODS_NAME(),
                        Vars.DATETIME(),
                        Vars.GOODS_AMOUNT(),
                        Vars.GROUP_NUM(),
                        Vars.GROUP_ENDDATE(),
                        Vars.GROUP_BEGINDATE(),
                        Vars.GROUP_CREATER(),
                    ]
                }
            ],
            currentTempKey: null,//当前正在新建的模板key值
            currentTempIndex: null,
            msgTempIndex: 0,//模板索引值
            seeVisible: false
        }

    }

    componentWillMount() {
        // if (this.isEdit()) {
        this.getSubscription();

        // } else {
        //     this.getSubscriptionList();
        // }
    }

    componentDidMount() {

    }

    showModal(key) {
        this.setState({
            [key]: true
        })
    }

    hideModal(key) {
        this.setState({
            [key]: false
        })
    }

    changeInput(key, e) {
        this.setState({
            [key]: e.target.value
        })
    }

    isCreate() {
        if (this.props.type == 'create') {
            return true;
        }

        return false;
    }

    isEdit() {
        if (this.props.type == 'edit') {
            return true;
        }

        return false;
    }

    getConfigId() {
        return this.state.appId;
    }

    // 得到公众号基本信息
    getSubscription() {
        Api.getSubscription((msg)=> {
            let list = {};
            let initAppId = null;
            list = msg;
            initAppId=msg.appId;
            this.setState({
                subscription: list,
                appId: initAppId,
            });
            this.getMsgTemp(initAppId);
            this.getDetail();
        })
    }


    stopRender() {
        this.setState({
            renderTemp: false
        })
    }

    // 获取消息详情
    getDetail() {
        let id = this.getConfigId();
        Api.getNoticeDetail(id, (msg)=> {
            let data = msg;
            let msgList = this.state.msgList;
            for (let i = 0; i < msgList.length; i++) {
                let key = msgList[i].key;
                if (data[key] && data[key] != 'null') {
                    msgList[i].currentMsg = JSON.parse(data[key]);
                    msgList[i].template_id = JSON.parse(data[key]).templateId
                }
            };

            let subscriptionList = [];
            let obj = {
                appId: data.appId,
                nickName: data.subsName,
                serviceType: 2,
                verifyType: 0,
            };
            subscriptionList.push(obj);

            this.setState({
                msgList_copy: msgList,
                appId: data.appId,
                name: data.name,
                subscriptionList: subscriptionList
            });
        })
        // fetchUtil.init()
        //     .setUrl(URL_MXD_GROUPBUY_NOTICE_DETAIL + '?appId=' + id)
        //     .setMethod("GET")
        //     .setCookieCors()
        //     .setBodyType('json')
        //     .dofetch()
        //     .then((msg) => {
        //         if (msg.respCode == 0) {
        //             let data = msg.respMsg;
        //             let msgList = this.state.msgList;
        //             for (let i = 0; i < msgList.length; i++) {
        //                 let key = msgList[i].key;
        //                 if (data[key] && data[key] != 'null') {
        //                     msgList[i].currentMsg = JSON.parse(data[key]);
        //                     msgList[i].template_id = JSON.parse(data[key]).templateId
        //                 }
        //             }
        //             ;
        //
        //             let subscriptionList = [];
        //             let obj = {
        //                 appId: data.appId,
        //                 nickName: data.subsName,
        //                 serviceType: 2,
        //                 verifyType: 0,
        //             };
        //             subscriptionList.push(obj);
        //
        //             this.setState({
        //                 msgList_copy: msgList,
        //                 appId: data.appId,
        //                 name: data.name,
        //                 subscriptionList: subscriptionList
        //             });
        //             // this.getSubscriptionList(data.appId);
        //         }
        //     })
        //     .catch(() => {
        //
        //     })
    }

    // 判断当前模板是否存在
    isExit(tempId) {
        let msgTemp = this.state.msgTemp;
        for (let i = 0; i < msgTemp.length; i++) {
            if (msgTemp[i].template_id == tempId) {
                return true;
            }
        }

        return false;
    }

    // 得到公众号列表
    // getSubscriptionList(appId) {
    //     fetchUtil.init()
    //         .setUrl(URL_GET_MSG_TEMPLATE_TASK_ACTIVE_LIST)
    //         .setMethod("GET")
    //         .setCookieCors()
    //         .setBodyType('json')
    //         .dofetch()
    //         .then((msg) => {
    //             if (msg.respCode == 0) {
    //                 let list = [];
    //                 if (msg.respMsg) {
    //                     list = msg.respMsg.subsList;
    //                 }
    //
    //                 let serviceList = [];
    //                 for (let i = 0; i < list.length; i++) {
    //                     if (list[i].serviceType == 2) {
    //                         serviceList.push(list[i])
    //                     }
    //                 }
    //
    //                 let initAppId = null;
    //                 if (serviceList.length > 0) {
    //                     initAppId = serviceList[0].appId;
    //                 }
    //
    //                 if (appId) {
    //                     initAppId = appId;
    //                     this.setSubs(serviceList, initAppId);
    //                 }
    //                 this.setState({
    //                     subscriptionList: serviceList,
    //                     appId: initAppId,
    //                 });
    //                 this.getMsgTemp(initAppId);
    //
    //             }
    //         })
    //         .catch(() => {
    //
    //         })
    // }

    setSubs(list, appId) {
        if (list && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].appId == appId) {
                    this.setState({
                        appIdIndex: i
                    })
                }
            }
        } else {
            setTimeout(() => {
                this.setSubs(list, appId);
            }, 200)
        }
    }

    // 公众号下拉框改变选择
    getSelectedFn(index) {
        let id = this.state.subscriptionList[index].appId;
        this.setState({
            appIdIndex: index,
            appId: id,
            renderTemp: true
        });

        this.getMsgTemp(id);
        this.clearMsgTemp();

    }

    // 清空已填写的消息模板
    clearMsgTemp() {
        let msgList = this.state.msgList;
        for (let i = 0; i < msgList.length; i++) {
            msgList[i].currentMsg = null;
            msgList[i].template_id = null;
        }
        this.setState({
            msgList: msgList
        })
    }

    // 获取消息模板
    getMsgTemp(appId) {
        Api.getMsgTemp(appId,(msg)=>{
            if (msg) {
                let list = msg.list;
                let template_id = null;
                if (list && list.length > 0) {
                    template_id = list[0].template_id;
                }
                this.setState({
                    msgTemp: list,
                    template_id: template_id,
                });
                // 编辑：判断当前添加的模板是否存在
                if (this.isEdit()) {
                    let msgList = this.state.msgList_copy;
                    for (let i = 0; i < msgList.length; i++) {
                        if (!this.isExit(msgList[i].template_id)) {
                            msgList[i].currentMsg = null;
                            msgList[i].template_id = null;
                        }
                    }
                    this.setState({
                        msgList: msgList
                    })
                }
            }
        })
    }

    // 更换消息模板
    changeMsg(index) {
        this.setState({
            msgTempIndex: index
        });
        this.setMsgData(this.state.appId, index)
    }

    //设置消息
    setMsgData(appId, index) {
        let msgTemp = this.state.msgTemp;
        let template_id = null;
        let msgData = null;
        if (msgTemp && msgTemp.length > 0) {
            let list = msgTemp[index];
            template_id = list.template_id;
            msgData = {
                appId: appId,
                content: list.content,
                data: {},
                link: {
                    type: 0
                },
                miniprogram: {},
                templateId: template_id,
                title: list.title,
                url: ""
            };
            this.setState({
                msg: msgData,
                template_id: template_id,
                msgTempIndex: index,
                renderTemp: true,
            })
        }
    }

    // 添加模板消息
    setCreateMsgModalVisible(index) {
        this.showModal('visible');
        let msgList = this.state.msgList;
        let currentTempKey = msgList[index].key;
        let currentTempName = msgList[index].name;
        let vars = msgList[index].vars;
        this.setState({
            currentTempKey: currentTempKey,
            currentTempIndex: index,
            currentTempName: currentTempName,
            vars: vars
        });
        setTimeout(() => {
            this.setMsgData(this.state.appId, 0)
        }, 200)
    }

    // 查看模板消息
    showPreview(index) {
        this.showModal('seeVisible');
        let msg = this.state.msg;
        let msgList = this.state.msgList;
        msg = msgList[index].currentMsg;
        let vars = msgList[index].vars;
        this.setState({
            msg: msg,
            vars: vars
        });
    }

    // 编辑模板消息
    showEditTemplateMsg(index) {
        this.setTempMsg(index);
        this.showModal('visible');
    }

    // 模板消息复现
    setTempMsg(index) {
        let msg = this.state.msg;
        let msgList = this.state.msgList;
        msg = msgList[index].currentMsg;
        let template_id = msgList[index].template_id;
        let currentTempName = msgList[index].name;
        let vars = msgList[index].vars;
        this.setState({
            msg: msg,
            template_id: template_id,
            renderTemp: true,
            currentTempIndex: index,
            currentTempName: currentTempName,
            vars: vars
        });
        this.setTempIndex(template_id);
    }

    // 模板消息名称复现（索引值）
    setTempIndex(id) {
        let msgTemp = this.state.msgTemp;
        let index = null;
        for (let i = 0; i < msgTemp.length; i++) {
            if (msgTemp[i].template_id == id) {
                index = i;
            }
        }

        this.setState({
            msgTempIndex: index
        })
    }

    // 新建模板保存
    saveMsgData() {
        let msgList = this.state.msgList;
        this.hideModal('visible');
        let index = this.state.currentTempIndex;
        // 获取模板消息内容
        let currentMsg = this.groupMsg.getData();
        msgList[index].currentMsg = currentMsg;
        msgList[index].template_id = this.state.template_id;
        this.setState({
            msgList: msgList
        });
    }

    // 隐藏模板弹窗
    cancelMsgData() {
        this.hideModal('visible');
        this.setMsgData(this.state.appId, 0)
    }

    // 取消
    cancel() {
        this.props.history.push(Path.getGroupBuyMsg());
    }

    // 获取提交数据
    getData() {
        let msgList = this.state.msgList;
        let obj = {};
        for (let i = 0; i < msgList.length; i++) {
            let key = msgList[i].key;
            obj[key] = JSON.stringify(msgList[i].currentMsg);
        }
        let data = {
            // name: this.state.name,
            appId: this.state.appId
        };

        let postData = Object.assign(data, obj);
        return postData;
    }

    // 完成
    submitData() {
        this.saveMsgData();
        let postData = this.getData();
        // if (!postData.appId) {
        //     Message.warning('请选择公众号');
        //     return false;
        // }
        // if (!postData.name) {
        //     Message.warning('请填写消息名称');
        //     return false;
        // }
        // let url = URL_GROUPBUY_NOTICECONFIG_ADD;
        // if (this.isEdit()) {
        //let  url = URL_MXD_GROUPBUY_NOTICE_ADD;
        postData.appId = this.getConfigId();
        // }
        this.hideModal('visible');
        Api.submitMsgTemp(postData, (msg)=>{
            if (this.isEdit()) {
                Message.success('编辑消息模板成功');
            } else {
                Message.success('新建消息模板成功');
            }
        },(err)=>{
            if (err.respCode == 1081) {
                Message.error('名称已存在')
            } else if (err.respCode == 1088) {
                Message.error('一个公众号只能建一个，请勿重复新建')
            } else {
                if (this.isEdit()) {
                    Message.error('编辑消息模板失败')
                } else {
                    Message.error('新建消息模板失败')
                }
            }
        })
    }

    render() {
        return (
            <div className="contentBody">
                <div className={'qy-panel minHeightNormalBot'}>

                    <div className={'activeListCreate templateWrapper'}>
                        <div className={'qy_detail'}>
                            <p className={'qy_detailTip'}>
                                公众号设置
                            </p>
                            <div style={{'height': '4px'}}></div>

                            <div className={'inlineItem paddin0 templateBottom'}>
                                <label className={'minWidth110'}>公众号：</label>
                                <div >
                                    {
                                        this.state.subscription?<div className={'clearfix'}>
                            <span  className={'baseInfoImg'} style={{backgroundImage: 'url("' + this.state.subscription.headimgurl + '")'}}>
                            </span>
                                            <span style={{lineHeight:"42px"}}>
                                {this.state.subscription.nickname}
                            </span>
                                            <p className={'text-gray fsize12'}>建议您配置授权自己的公众号，提高公众号涨粉     <span className={'text-primary cursor-pointer'}>去授权自己的公众号</span> </p>
                                        </div>: <p className={'text-gray fsize12'}>建议您配置授权自己的公众号，提高公众号涨粉     <span className={'text-primary cursor-pointer'}>去授权自己的公众号</span> </p>

                                    }
                                </div>
                            </div>
                            <div className={'inlineItem paddin0'}>
                                <label className={'minWidth110'}><span className='text-danger'>*</span>配置名称：</label>
                                <span>
                                <div className={'word-limit-wrapper goods_name'}>
                                     <Input placeholder="请输入配置名称"
                                            maxLength={Vars.ST_TITLE_MAX_LENGTH()} className={'inline-control'}
                                            value={this.state.name}
                                            onChange={this.changeInput.bind(this, 'name')}
                                     />
                                <span
                                    className='word-limit'>{(this.state.name ? this.state.name.length : '0') + '/' + Vars.ST_TITLE_MAX_LENGTH()}</span>
                                </div>
                            </span>
                            </div>
                        </div>
                        <div style={{'height':'15px'}}></div>

                        <div className={'qy_detail'}>
                            <p className={'qy_detailTip'}>
                                消息设置
                            </p>
                            <div className={'template-form-item'}>
                                <div className={'templateInline'}>
                                    {
                                        this.state.msgList.map((list, index) => (
                                            <div className={'templateItem'}>
                                                <div className="mxd-form-title"><label>{list.name}</label></div>
                                                <div className={'clearfix'}>
                                                    {
                                                        list.currentMsg ?
                                                            <div className={manageStyles.mangeMsgCard + ' ' + styles.msgCard}>
                                                                <MsgPreview key="1"
                                                                            msg={list.currentMsg ? list.currentMsg : null}
                                                                            lite="true"/>
                                                                <div className={styles.msgMask}>
                                                                    <div className={styles.msgMaskIcon}>
                                                                        <EyeOutlined onClick={this.showPreview.bind(this, index)} />
                                                                        <FormOutlined onClick={this.showEditTemplateMsg.bind(this, index)} />
                                                                    </div>
                                                                </div>
                                                            </div> :
                                                            <div>
                                                                <DashedAddButton addText={'添加模板消息'} width="220px"
                                                                                 height="220px"
                                                                                 onClick={this.setCreateMsgModalVisible.bind(this, index)}/>
                                                            </div>
                                                    }
                                                </div>
                                                <div className="mxd-triggerend"></div>
                                            </div>
                                        ))
                                    }
                                </div>

                            </div>
                        </div>
                    </div>

                    {/*<PopupMask>*/}
                    {/*    <div className="bottom-pannel">*/}
                    {/*        <div className='bottom-btns'>*/}
                    {/*            <Button onClick={this.cancel.bind(this)}>取消</Button>*/}
                    {/*            <Button type="primary" onClick={this.submitData.bind(this)}*/}
                    {/*                    disabled={this.state.disabled}>完成</Button>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</PopupMask>*/}
                </div>

                {/*新建模板弹窗*/}
                <Modal title={'新建' + (this.state.currentTempName) + '消息'}
                       visible={this.state.visible}
                       className={'MsgTemplateWrapper'}
                       onCancel={this.cancelMsgData}
                    // onOk={this.saveMsgData.bind(this)}
                       onOk={this.submitData.bind(this)}
                       forceRender={true}
                >
                    {/*消息模板组件*/}
                    <MsgTemplate msg={this.state.msg} id={'groupMsgTemp'}
                                 template_id={this.state.template_id}
                                 vars={this.state.vars}
                                 appId={this.state.appId}
                                 renderTemp={this.state.renderTemp}
                                 stopRender={this.stopRender.bind(this)}
                                 ref={r => {this.groupMsg = r}}
                    >
                        <div className={'msgTemplateSelect ' + styles.inputContainer}>
                            <Row gutter={20}>
                                <Col span={6} align="right">
                                    <label>消息标题</label>
                                </Col>
                                <Col span={18}>

                                    {
                                        this.state.msgTemp && this.state.msgTemp.length > 0 ?
                                            <Select defaultValue={0}
                                                    value={this.state.msgTempIndex}
                                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                                    suffixIcon={<CaretDownOutlined />}
                                                    onChange={this.changeMsg.bind(this)}
                                            >
                                                {
                                                    this.state.msgTemp.map((temp, index) => (
                                                        <Option value={index}>{temp.title}</Option>
                                                    ))
                                                }
                                            </Select> :
                                            <Select defaultValue={0}
                                                    value={0}
                                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                                    suffixIcon={<CaretDownOutlined />}
                                            >
                                                <Option value={0}>暂无模板</Option>
                                            </Select>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </MsgTemplate>
                </Modal>

                {/*消息查看弹窗*/}
                <Modal title={null}
                       visible={this.state.seeVisible}
                       onCancel={this.hideModal.bind(this, 'seeVisible')}
                       className={'hasNoContent'}
                       footer={null}
                >
                    <div className={manageStyles.phonebg}>
                        <div className={manageStyles.phoneScroll} ref="phoneScroll"
                             onMouseOver={this.mouseOverPhoneScroll}
                             onMouseLeave={this.mouseLeavePhoneScroll}>
                            <div className={manageStyles.phoneContent}>
                                {
                                    this.state.msg ?
                                        <MsgPreview msg={this.state.msg}/> : ''
                                }
                            </div>
                        </div>
                    </div>

                </Modal>

            </div>
        );
    }
}


export default GroupCodeData




